export enum NewsArticleTypeEnum {
  ARTICLE = 'ARTICLE',
  NEWS = 'NEWS',
}